export const phoneDigits = (value: string | null | undefined): string => {
  return (value ?? '').replace(/\D/g, '');
};

export const toUsPhoneNumber = (value: string | null | undefined): string => {
  return `+1${phoneDigits(value)}`;
};

export const US_PHONE_DIGITS = 10;

export const localUsDigits = (value: string | null | undefined): string => {
  const digits = phoneDigits(value);
  const local =
    digits.length === US_PHONE_DIGITS + 1 && digits.startsWith('1')
      ? digits.slice(1)
      : digits;
  return local.slice(0, US_PHONE_DIGITS);
};

export const nextUsPhoneDigits = (previous: string, input: string): string => {
  const digits = phoneDigits(input);
  if (digits.length <= US_PHONE_DIGITS) return digits;
  const isFullAlready = previous.length === US_PHONE_DIGITS;
  return isFullAlready && !input.trimStart().startsWith('+')
    ? previous
    : localUsDigits(input);
};

export const formatUsPhone = (value: string | null | undefined): string => {
  const digits = localUsDigits(value);
  if (digits.length <= 3) return digits;
  const area = `(${digits.slice(0, 3)})`;
  if (digits.length <= 6) return `${area} ${digits.slice(3)}`;
  return `${area} ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const toSubmittedPhoneNumber = (
  value: string | null | undefined
): string => {
  const phone = value ?? '';
  if (phone.startsWith('+1')) return phone;
  return toUsPhoneNumber(phone);
};
